import {
  showNotification,
  UploadedFileFormatIsNotAllowedBySpecifiedAcceptedField,
} from 'platform/components';

import i18n from '@dms/i18n';

export const notifyUnsupportedImageFormat = (error: Error) => {
  if (error instanceof UploadedFileFormatIsNotAllowedBySpecifiedAcceptedField) {
    showNotification.error(i18n.t('entity.promoPhotos.notifications.imageFormatIsNotAllowed'));
  }
};
